import React, { useState } from "react";
import axios from "axios"; // Import axios
import { Snackbar, Alert as MuiAlert } from "@mui/material"; // Import Snackbar from MUI
// import "./Forms.css";
import "./Modal.css";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import API_URL from "../Config"; // Adjust the path based on your file structure

export default function ServiceMasterModal({ onClose, onSave }) {
  const [formData, setFormData] = useState({
    serviceName: "",
    purchaseCost: "",
    sellingCost: "",
    gst: "",
  });

  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [formErrors, setFormErrors] = useState({
    serviceName: "",
    purchaseCost: "",
    sellingCost: "",
    gst: "",
  });

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // success or error
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    setFormErrors({
      ...formErrors,
      [name]: "",
    });
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.serviceName) {
      errors.serviceName = "Service Name is required.";
    }

    if (!formData.purchaseCost) {
      errors.purchaseCost = "Purchase Cost is required.";
    } else if (isNaN(formData.purchaseCost) || formData.purchaseCost <= 0) {
      errors.purchaseCost = "Purchase Cost must be a positive number.";
    }

    if (!formData.sellingCost) {
      errors.sellingCost = "Selling Cost is required.";
    } else if (isNaN(formData.sellingCost) || formData.sellingCost <= 0) {
      errors.sellingCost = "Selling Cost must be a positive number.";
    }

    if (!formData.gst) {
      errors.gst = "GST is required.";
    } else if (isNaN(formData.gst) || formData.gst < 0 || formData.gst > 100) {
      errors.gst = "GST must be a number between 0 and 100.";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0; // Return true if no errors
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!validateForm()) {
  //     return; // If validation fails, stop the submission
  //   }

  //   const serviceData = {
  //     service_name: formData.serviceName,
  //     purchase_cost: formData.purchaseCost,
  //     selling_cost: formData.sellingCost,
  //     gst_rate: formData.gst,
  //   };

  //   const authKey = localStorage.getItem("authKey");

  //   try {
  //     const response = await axios.post(
  //       `${API_URL}/api/create_service`,
  //       serviceData,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${authKey}`, // Adding the authKey in Authorization header
  //         },
  //       }
  //     );
  //     // Handle success (e.g., display a success message)
  //     setSnackbarMessage("Service Master created successfully!");
  //     setSnackbarSeverity("success");
  //     setSnackbarOpen(true);
  //     setError(null); // Clear any previous error
  //     onClose()
  //   } catch (err) {
  //     // Handle error from API
  //     setSnackbarMessage(err.response?.data.message || "Something went wrong.");
  //     setSnackbarSeverity("error");
  //     setSnackbarOpen(true);
  //     setSuccessMessage(null); // Clear any previous success message
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return; // Stop submission if validation fails
    }

    const serviceData = {
      service_id: Date.now(), // Temporary unique ID
      service_name: formData.serviceName,
      purchase_cost: formData.purchaseCost,
      selling_cost: formData.sellingCost,
      gst_rate: formData.gst,
    };

    console.log("📤 Sending Service Data from Modal to Parent:", serviceData);

    try {
      const response = await axios.post(
        `${API_URL}/api/create_service`,
        serviceData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authKey")}`,
          },
        }
      );

      if (response.status === 200) {
        console.log("✅ Service Created in Backend:", response.data);

        if (onSave) {
          console.log(
            "🔄 Calling onSave() in Parent with Data:",
            response.data
          );
          const savedService = {
            service_id: response.data.service_id, // Backend ID
            service_name: formData.serviceName, // User input
            purchase_cost: formData.purchaseCost,
            selling_cost: formData.sellingCost,
            gst_rate: formData.gst,
          };

          console.log(
            "🔄 Merging Backend Response with Form Data:",
            savedService
          );
          onSave(savedService); // ✅ Send full data to parent
        }

        setSnackbarMessage("Service Master created successfully!");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);

        onClose(); // Close modal
      } else {
        console.error("❌ API Error: Failed to create service.");
        setSnackbarMessage("Failed to create service. Please try again.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } catch (err) {
      console.error("❌ Error from API:", err.response?.data || err);
      setSnackbarMessage(
        err.response?.data?.message || "Something went wrong."
      );
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <div className="popup-overlay">
      <div className="modal-container">
        <div className="table-container">
          <div className="table-container-content form-main-body">
            <h1 className="form-title jost-bold">New Service Master</h1>
            <div className="form-body form-body-popup">
              <form onSubmit={handleSubmit} className="form-box">
                <div className="form-body-container">
                  <div className="form-group">
                    <label className="form-label jost-regular">
                      Service Name<span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      className="input-field"
                      placeholder="Enter Service Name"
                      name="serviceName"
                      value={formData.serviceName}
                      onChange={handleChange}
                    />
                    {formErrors.serviceName && (
                      <div className="error-message">
                        {formErrors.serviceName}
                      </div>
                    )}
                  </div>

                  <div className="form-group">
                    <label className="form-label jost-regular">
                      Purchase Cost <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      className="input-field"
                      placeholder="Enter Purchase Cost"
                      name="purchaseCost"
                      value={formData.purchaseCost}
                      onChange={handleChange}
                    />
                    {formErrors.purchaseCost && (
                      <div className="error-message">
                        {formErrors.purchaseCost}
                      </div>
                    )}
                  </div>

                  <div className="form-group">
                    <label className="form-label jost-regular">
                      Selling Cost <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      className="input-field"
                      placeholder="Enter Selling Cost"
                      name="sellingCost"
                      value={formData.sellingCost}
                      onChange={handleChange}
                    />
                    {formErrors.sellingCost && (
                      <div className="error-message">
                        {formErrors.sellingCost}
                      </div>
                    )}
                  </div>

                  <div className="form-group">
                    <label className="form-label jost-regular">
                      GST in % <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      className="input-field"
                      placeholder="Enter GST in %"
                      name="gst"
                      value={formData.gst}
                      onChange={handleChange}
                    />
                    {formErrors.gst && (
                      <div className="error-message">{formErrors.gst}</div>
                    )}
                  </div>

                  {/* Display success or error message */}
                </div>
              </form>
            </div>
            <div className="form-footer">
              <div className="button-group">
                <button
                  type="button"
                  className="btn btn-cancel"
                  onClick={handleCancel}
                >
                  CANCEL
                </button>
                <button
                  type="submit"
                  className="btn btn-save"
                  onClick={handleSubmit}
                >
                  SAVE
                </button>
              </div>
            </div>
          </div>

          {/* Snackbar to display success or error message */}
          <Snackbar
            open={snackbarOpen}
            autoHideDuration={6000}
            onClose={handleSnackbarClose}
          >
            <MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity}>
              {snackbarMessage}
            </MuiAlert>
          </Snackbar>
        </div>
      </div>
    </div>
  );
}
